import { cn as _ } from "../../../lib/utils.es.js";
import { textVariants as x } from "./Text.variants.es.js";
import { jsx as E } from "react/jsx-runtime";
import { Slot as l } from "@radix-ui/react-slot";
var n = "div", u = ({ as: r, children: t, size: o, color: m, weight: a, align: e, className: i, fontFamily: f, asChild: p, ...s }) => /* @__PURE__ */ E(p ? l : r ?? n, {
  className: _(x({
    size: o,
    fontFamily: f,
    weight: a,
    color: m,
    align: e,
    className: i
  })),
  ...s,
  children: t
});
export {
  u as default
};
